<template>
  <validation-observer ref="simpleRules">
    <div>
      <b-form enctype="multipart/forn-data">
        <div class="d-flex mb-2 mt-2">
          <feather-icon icon="ImageIcon" size="19" />
          <h4 class="mb-0 ml-50">Image (Max Size 2Mb)</h4>
        </div>
        <!-- Media -->
        <b-media class="mb-2">
          <template #aside>
            <b-avatar :src="userData.images" size="90px" rounded />
          </template>
          <div class="d-flex flex-wrap">
            <b-button variant="primary" @click="$refs.refInputEl.click()">
              <input
                ref="refInputEl"
                type="file"
                @change="uploadImage"
                class="d-none"
              />
              <span class="d-none d-sm-inline">Update</span>
              <feather-icon icon="EditIcon" class="d-inline d-sm-none" />
            </b-button>
          </div>
        </b-media>
        <div class="d-flex mb-2 mt-2">
          <feather-icon icon="BoxIcon" size="19" />
          <h4 class="mb-0 ml-50">Product Detail</h4>
        </div>
        <!-- User Info: Input Fields -->
        <b-row>
          <!-- Field: sku -->

          <!-- Field: identification_number -->
          <b-col cols="12" md="4">
            <b-form-group label="Name" label-for="name">
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="name"
              >
                <b-form-input
                  id="name"
                  v-model="userData.name"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Last  Name -->
          <b-col cols="12" md="4">
            <b-form-group label="Price" label-for="price">
              <validation-provider
                #default="{ errors }"
                rules="required|between:0.1,99999"
                name="Price"
              >
                <b-form-input
                  id="Price"
                  v-model="userData.inventory_price"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <!-- Field: Status -->
          <b-col cols="12" md="4">
            <b-form-group label="Status" label-for="user-status">
              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="statusOptions"
                :reduce="(val) => val.value"
                :clearable="false"
                v-model="userData.status"
                input-id="user-status"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4">
            <b-form-group label="Discount" label-for="user-type">
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="Discount"
              >
                <v-select
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :options="discountOptions"
                  :reduce="(val) => val.value"
                  :clearable="false"
                  v-model="userData.discount"
                  input-id="user-type"
                  @input="
                    userData.discount > 0
                      ? ((showValueDiscount = true), calculateOfferPrice())
                      : ((showValueDiscount = false), calculateOfferPrice())
                  "
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="4" v-show="showValueDiscount">
            <b-form-group label="Value Discount" label-for="value_discount">
              <b-form-input
                id="value_discount"
                v-model="userData.discount_value"
                @change="calculateOfferPrice()"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4" v-show="showValueDiscount">
            <b-form-group label="Price Discount" label-for="price_discount">
              <validation-provider
                #default="{ errors }"
                rules="required|between:0.1,99999"
                name="Price discount "
              >
                <b-form-input
                  id="price_discount"
                  v-model="userData.price"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12">
            <div class="d-flex mb-2 mt-2">
              <feather-icon icon="BoldIcon" size="19" />
              <h4 class="mb-0 ml-50">Detail Product Description</h4>
            </div>
            <div style="height: 420px">
              <quill-editor
                style="height: 350px"
                v-model="userData.description"
                :options="snowOption"
              />
            </div>
          </b-col>
        </b-row>
        <div class="mt-2">
          <b-button
            variant="primary"
            type="submit"
            @click.prevent="validationForm"
          >
            Update Service
          </b-button>
        </div>
      </b-form>
    </div>
  </validation-observer>
</template>

<script>
import {
  BButton,
  BMedia,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BTable,
  BCard,
  BCardHeader,
  BCardTitle,
  BFormCheckbox,
  BFormTextarea,
  BFormDatepicker,
} from "bootstrap-vue";

import vSelect from "vue-select";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";
import { ref, onUnmounted } from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
//import useUsersList from "../employee-list/EmployeeList.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";

export default {
  components: {
    BButton,
    BMedia,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BFormCheckbox,
    vSelect,
    BFormTextarea,
    BFormDatepicker,
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const toast = useToast();
    const validations = ref({
      required,
      confirmed,
      password,
      email,
      min,
      integer,
      url,
      alpha,
      between,
      digits,
      length,
      alphaDash,
    });

    const snowOption = snowOption;

    const imgAvatar = ref("");

    const cityOptions = ref([]);

    const simpleRules = ref(null);
    let showValueDiscount = ref();

    const statusOptions = [
      { label: "True", value: true },
      { label: "False", value: false },
    ];

    const typeCommission = [
      { label: "%", value: 1 },
      { label: "Fixed", value: 2 },
    ];

    const discountOptions = [
      { label: "False", value: 0 },
      { label: "%", value: 1 },
      { label: "Fixed", value: 2 },
    ];

    const calculateOfferPrice = () => {
      if (props.userData.discount == 1) {
        let descuento =
          (props.userData.discount_value * props.userData.inventory_price) /
          100;
        props.userData.price = props.userData.inventory_price - descuento;
      } else if (props.userData.discount == 2) {
        props.userData.price =
          props.userData.inventory_price - props.userData.discount_value;
      } else {
        props.userData.price = props.userData.inventory_price;

        props.userData.discount_value = 0;
      }
    };

    if (props.userData.discount > 0) {
      showValueDiscount = true;
    } else {
      showValueDiscount = false;
    }

    const a = [];
    store
      .dispatch("app-user/fetchHelpers")
      .then((response) => {
        const { cities } = response.data.data;

        cities.map((data, item) => {
          a.push({ label: data.name, value: data.id, id: item });
        });
        console.log(a);
        cityOptions.value = a;
      })
      .catch((error) => {
        if (error.response.status === 404) {
          userData.value = undefined;
        }
      });

    const uploadImage = (e) => {
      let file = e.target.files[0];
      if (file.size > 2097152) {
        return toast({
          component: ToastificationContent,
          props: {
            title: `ERROR`,
            icon: "AlertOctagonIcon",
            variant: "danger",
            text: `image exceeds the allowed weight 2Mb`,
            solid: true,
          },
        });
      }
      Object.assign(props.userData, { file: file });
      viewImage(file);
    };

    const viewImage = (imageP) => {
      let reader = new FileReader();
      reader.onload = (e) => {
        props.userData.images = e.target.result;
      };
      reader.readAsDataURL(imageP);
    };

    const validationForm = () => {
      simpleRules.value.validate().then((success) => {
        if (success) {
          console.log("vamos guardar el DATAAA->", props.userData);

          let formData = new FormData();
          formData.append("id", props.userData.id);
          formData.append("description", props.userData.description);
          formData.append("file", props.userData.file);
          formData.append("name", props.userData.name);
          formData.append("price", props.userData.price);
          formData.append("inventory_price", props.userData.inventory_price);
          formData.append("discount", props.userData.discount);
          formData.append("discount_value", props.userData.discount_value);
          formData.append("status", props.userData.status);
          formData.append("idOffice", router.currentRoute.query.idOffice);

          store
            .dispatch("app-user/updateService", formData)
            .then((response) => {
              console.log("RESPONSE=>", { response });
              toast({
                component: ToastificationContent,
                props: {
                  title: `SUCCESS`,
                  icon: "CheckCircleIcon",
                  text: `${response.data.msg}`,
                  variant: "success",
                },
              });
              router.push({ name: "apps-service-list" });
            })
            .catch((err) => {
              console.log("ERRRRO=>", err);
              toast({
                component: ToastificationContent,
                props: {
                  title: `ERROR`,
                  icon: "AlertOctagonIcon",
                  variant: "danger",
                  text: `${err}`,
                  solid: true,
                },
              });
            });
        }
      });
    };

    // ? Demo Purpose => Update image on click of update
    const refInputEl = ref(null);
    const previewEl = ref(null);

    const { inputImageRenderer } = useInputImageRenderer(
      refInputEl,
      (base64) => {
        console.log("ENtre Aqui");
      }
    );

    return {
      cityOptions,
      statusOptions,
      validations,
      uploadImage,
      imgAvatar,
      simpleRules,
      validationForm,
      snowOption,
      //  ? Demo - Update Image on click of update button
      refInputEl,
      previewEl,
      inputImageRenderer,
      calculateOfferPrice,
      discountOptions,
      showValueDiscount,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
